import React from "react";
import { OctalCalculator } from "../components/OctalCalculator";

const Octal = () =>
{
    return (
            <OctalCalculator></OctalCalculator>
        
    )
}

Octal.defaultProps = {};

export default Octal;